import { Controller, useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useState } from "react";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import { lineOfBusinessInfo } from "../types";
import { useRecoilValue } from "recoil";
import { editStateLineOfBusiness } from "../atoms/atoms";
import SelectHookFormSingle from "../../../../../components/SelectHookFormSingle";
import useGetBusinessTypes from "../../BusinessType/hooks/useGetBusinessTypes";

const LineOfBusinessDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: lineOfBusinessInfo | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateLineOfBusiness);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.lineOfBusinessName || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [dropBoxChanges, setDropBoxChanges] = useState(
    data?.businessTypeId || ""
  );

  const { data: businessTypes, isLoading: businessTypeLoading } =
    useGetBusinessTypes();
  const businessTypeOptions = businessTypes?.data
    ?.filter((x) => x.isActive === true)
    .map((x) => {
      return {
        label: x.businessTypeName,
        value: x.businessTypeId,
      };
    });

  const allBusinessTypeOpt = businessTypeOptions && [...businessTypeOptions];

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg- rounded-md box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-2 gap-x-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="lineOfBusinessName"
                label="Line of Business Name"
                type="text"
                required={true}
                onChange={(e) => {
                  setInputData(e.target.value);
                  if (
                    e.target.value.length === 0 ||
                    dropBoxChanges === "" ||
                    (e.target.value === data?.lineOfBusinessName &&
                      checkBoxChanges === data?.isActive &&
                      dropBoxChanges === data?.businessTypeId)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                className={
                  formMethods.formState.errors.lineOfBusinessName &&
                  formMethods.formState.errors.lineOfBusinessName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("lineOfBusinessName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="col-span-2 my-1">
              <Controller
                name="businessTypeId"
                control={formMethods.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    isClearable={false}
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      setDropBoxChanges(e.value);
                      if (
                        e.value === 0 ||
                        inputData === "" ||
                        (e.value === data?.businessTypeId &&
                          checkBoxChanges === data?.isActive &&
                          inputData === data?.lineOfBusinessName)
                      ) {
                        setChanges(false);
                      } else {
                        setChanges(true);
                      }
                    }}
                    value={field.value}
                    isLoading={businessTypeLoading}
                    options={allBusinessTypeOpt}
                    label="Business Type Name"
                    className={
                      formMethods.formState.errors.state &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    required={true}
                  />
                )}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  type="checkbox"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.lineOfBusinessName &&
                        dropBoxChanges === data?.businessTypeId)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LineOfBusinessDetails;
